<template>
  <b-button @click="startEventPreview()" type="is-primary">
    {{ text }}
  </b-button>
</template>

<script>
import EventPreview from '~/components/modals/EventPreview'
import EventControls from '~/components/mixins/EventControls'
import { demoDeckId } from '~/common/decks'

export default {
  name: 'PlayDemoButton',
  mixins: [ EventControls ],
  props: {
    text: {
      type: String,
      default: 'Play the Demo'
    },
    trackingData: {
      type: Object,
      default: () => ({
        location: ''
      })
    }
  },
  mounted () {
    if (this.$route.hash === '#startdemo') {
      this.startEventPreview()
      this.$router.replace({ hash: '' })
    }
  },
  methods: {
    async startEventPreview () {
      this.posthogCapture('onboard:demo_start', { from_location: this.trackingData.location })
      this.saveOnboarding('onboard-demo-started')

      this.log('starting new live demo')
      const event = await this.startEventById(demoDeckId, { stopRedirect: true, isPreviewEvent: true })
      const shortcode = event.shortcode
      const timestamp = Date.now()
      this.$store.commit('saveEventPreviewCode', {
        deckId: demoDeckId,
        shortcode,
        timestamp
      })

      this.$buefy.modal.open({
        parent: this,
        component: EventPreview,
        customClass: 'event-preview-modal',
        canCancel: false,
        trapFocus: true,
        onCancel: () => {
          this.log('EventPreview onCancel')
          return false
        },
        events: {
          close: (options = {}) => {
            this.log('EventPreview close event')
            if (options.showCompletedToast) {
              this.$buefy.toast.open({ type: 'is-primary', message: `Congrats, you've completed the demo!` })
            } else {
              const { id, shortcode, position } = options.event || {}
              this.posthogCapture('onboard:demo_cancel', {
                event_id: id,
                shortcode,
                slide: position?.currentSlide,
                step: position?.step
              })
            }
          }
        },
        props: {
          deckId: demoDeckId,
          shortcode
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
